import React, { useState, useRef } from "react";
import "./faq.css";
import dot from "../../assets/dots.svg";

const faqItems = [
  {
    number: "01",
    title: "How does AgentSRE integrate with my existing stack?",
    content:
      "AgentSRE ingests logs, metrics, and traces directly from OpenTelemetry, Prometheus, Datadog, and other observability tools. It connects through APIs and scripts, so you can start without replacing your current stack.",
  },
  {
    number: "02",
    title: "Can it scale across hybrid/multi-cloud?",
    content:
      "Yes — AgentSRE runs across Kubernetes, cloud-native, and hybrid environments. Its fleet of AI agents adapts to multi-cloud architectures to deliver consistent detection, RCA, and remediation at enterprise scale.",
  },
  {
    number: "03",
    title: "How does it ensure compliance (PCI-DSS, SOC2)?",
    content:
      "AgentSRE enforces tagging, access policies, and audit trails automatically. It aligns remediation workflows with PCI-DSS and SOC2 requirements, while dashboards keep compliance status audit-ready.",
  },
  {
    number: "04",
    title: "What makes it “Agentic AI” vs. AIOps?",
    content:
      "Traditional AIOps surfaces alerts and correlations. AgentSRE goes further with autonomous, specialized AI agents that detect, diagnose, and remediate issues — acting on your behalf while keeping humans in the loop when needed.",
  },
  {
    number: "05",
    title: "Can it handle database-level or pod-level incidents?",
    content:
      "Yes — specialized agents handle incidents at every layer, from Kubernetes pods to databases. They can restart services, roll back configurations, or optimize queries in real time to restore reliability quickly.",
  },
  {
    number: "06",
    title: "Does it reduce infra load (batch → real-time)?",
    content:
      "Absolutely — AgentSRE shifts from batch-based monitoring to real-time detection and remediation. This reduces alert storms, optimizes infra usage, and prevents costly downtime before customers are impacted.",
  },
];

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const contentRefs = useRef([]);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="second-faq-section" id="faq">
      <div className="container">
        <div className="section-heading">
          <div className="section-tag">
            <img src={dot} alt="dot-image" />
            <p>FAQ</p>
          </div>
          <div className="second-faq-section-heading">
            <h2>FAQ - Ask your questions</h2>
            <p>
              Everything You Need to Know About AgentSRE
            </p>
          </div>
        </div>

        <div className="second-accordion">
          {faqItems.map((item, index) => (
            <div className="second-accordion-item" key={index}>
              <button
                id={`second-accordion-button-${index}`}
                aria-expanded={openIndex === index}
                onClick={() => toggleAccordion(index)}
              >
                <span className="second-accordion-title">{item.title}</span>
                <span className="icon" aria-hidden="true"></span>
              </button>

              <div
                ref={(el) => (contentRefs.current[index] = el)}
                className={`second-accordion-content ${
                  openIndex === index ? "open" : ""
                }`}
                style={{
                  maxHeight:
                    openIndex === index
                      ? `${contentRefs.current[index]?.scrollHeight}px`
                      : "0px",
                  opacity: openIndex === index ? 1 : 0,
                }}
              >
                <p>{item.content}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
